<template>
  <a-modal
    :title="dialogTitle"
    :visible="visible"
    :mask-closable="false"
    :width="450"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <a-form-model
      ref="form"
      :model="form"
      label-align="right"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      :rules="validateRules"
    >
      <a-form-model-item
        label="基地"
        prop="baseId"
      >
        <a-select
          v-model="form.baseId"
          placeholder="请选择基地"
          allow-clear
          show-search
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in baseOptions"
            :key="item.baseId"
          >
            {{ item.baseName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label="产品类型:"
        prop="productTypeId"
      >
        <a-select
          v-model="form.productTypeId"
          placeholder="请选择产品类型"
          allow-clear
          show-search
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="item in productTypetions"
            :key="item.productTypeId"
          >
            {{ item.productTypeName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label="计收时间"
        prop="date"
      >
        <a-month-picker
          v-model="form.date"
          :format="monthFormat"
          placeholder="请选择计收时间"
          style="width: 100%;"
          @change="changeMonth"
        />
      </a-form-model-item>
      <a-form-model-item
        label="含税收入"
        prop="taxIncome"
      >
        <a-input
          v-model="form.taxIncome"
          placeholder="请选择含税收入"
        />
      </a-form-model-item>
      <a-form-model-item
        label="税率"
        prop="taxRate"
      >
        <a-input-number
          v-model="form.taxRate"
          :formatter="value => `${value}%`"
          :parser="value => value.replace('%', '')"
          placeholder="请输入税率"
          allow-clear
          style="width: 100%;"
        />
      </a-form-model-item>
      <a-form-model-item
        label="备注"
        prop="remark"
      >
        <a-input
          v-model="form.remark"
          placeholder="请填写备注"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateTaxIncome, addTaxIncome } from '@/api/vocherIncome'
import moment from 'moment'
import { deepClone, filterOption } from '@/utils/utils.js'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    baseOptions: {
      type: Array,
      default: null
    },
    initData: {
      type: Object,
      default: null
    },
    dialogTitle: {
      type: String,
      default: null
    },
    productTypetions: {
      type: Array,
      default: null
    },
    actionType: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      form: {
        baseId: undefined,
        productTypeId: undefined,
        date: '',
        taxIncome: undefined,
        taxRate: undefined,
        remark: undefined
      },
      validateRules: {
        baseId: [{ required: true, message: '请选择基地', trigger: 'change' }],
        productTypeId: [{ required: true, message: '请输入回款金额', trigger: 'change' }],
        date: [{ required: true, message: '请选择回款时间', trigger: 'change' }],
        taxIncome: [{ required: true, message: '请选择含税收入', trigger: 'change' }],
        taxRate: [{ required: true, message: '请选择税率', trigger: 'change' }]
      },
      baseTemp: [],
      monthFormat: 'YYYY-MM'
    }
  },
  watch: {
    initData: {
      deep: true,
      handler: function (data) {
        // Object.assign(this.form, data)
        this.form = this.deepClone(data)
      }
    }
  },
  methods: {
    moment,
    deepClone,
    filterOption,
    handleCancel () {
      this.$refs.form.resetFields()
      this.$emit('cancel')
    },
    changeMonth (date, dateString) {
      this.form.date = dateString
    },
    handleOk () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.actionType === '0') {
            updateTaxIncome(
              {
                ...this.form
              }
            )
              .then(() => {
                this.$emit('ok')
                this.$message.success('提交成功!')
              })
          } else {
            addTaxIncome(
              {
                ...this.form
              }
            )
              .then(() => {
                this.$emit('ok')
                this.$message.success('提交成功!')
              })
          }
        }
      })
    }
  }
}
</script>
